import React from 'react';

const AVATAR_COLORS = [
    ['#FF7A1A', '#C2530A'],
    ['#7B5BFF', '#4F33CC'],
    ['#12B8A0', '#0A8270'],
    ['#FF5470', '#D62F50'],
    ['#36A9F0', '#1A7CC0'],
    ['#FFC42E', '#E09A00'],
];

const colorForId = (id = '') => {
    let h = 0;
    for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
    return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

const PlayerWords = ({ player, words, onWordSelect, selectedWords, isCurrentPlayer, currentDelay,
    currentTurn, isLeader }) => {
    const sortedWords = [...words].sort((a, b) => a.length !== b.length ? a.length - b.length : a.localeCompare(b));
    const playerSelectedWords = selectedWords.filter(item => item.playerID === player.id).map(item => item.word);
    const [face, edge] = colorForId(player.id);
    const locked = currentDelay > 0 || currentTurn === -2;

    return (
        <div
            className="sg-card"
            style={{
                padding: '16px',
                marginBottom: '14px',
                position: 'relative',
                overflow: 'hidden',
                ...(isCurrentPlayer
                    ? { boxShadow: '0 0 0 3px var(--grape), var(--soft-shadow)' }
                    : {}),
            }}
        >
            <div className="sg-row" style={{ justifyContent: 'space-between', gap: '10px', marginBottom: sortedWords.length ? '12px' : 0 }}>
                <div className="sg-row" style={{ gap: '10px', minWidth: 0 }}>
                    <span
                        style={{
                            width: 38, height: 38, flexShrink: 0,
                            borderRadius: '12px',
                            background: face, boxShadow: `0 3px 0 ${edge}`,
                            display: 'grid', placeItems: 'center',
                            color: '#fff', fontWeight: 900, fontSize: '1.1rem',
                            textTransform: 'uppercase',
                        }}
                    >
                        {(player.name || '?').trim().charAt(0)}
                    </span>
                    <div className="sg-stack" style={{ minWidth: 0 }}>
                        <span style={{ fontWeight: 800, fontSize: '1.05rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {isLeader && player.score > 0 && <span style={{ marginRight: 4 }}>👑</span>}
                            {player.name}
                        </span>
                        {isCurrentPlayer && <span className="sg-kicker" style={{ fontSize: '0.62rem' }}>that's you</span>}
                    </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.7rem', lineHeight: 1, color: 'var(--ink)' }}>
                        {player.score}
                    </div>
                    <div className="sg-faint" style={{ fontWeight: 700, fontSize: '0.66rem', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                        {player.score === 1 ? 'point' : 'points'}
                    </div>
                </div>
            </div>

            {sortedWords.length > 0 ? (
                <div className="sg-wrap" style={{ gap: '8px' }}>
                    {sortedWords.map((word, index) => (
                        <button
                            key={index}
                            onClick={() => onWordSelect(word, player.id, index)}
                            disabled={locked}
                            className={[
                                'sg-word',
                                playerSelectedWords.includes(word) ? 'sg-word--selected' : '',
                                locked ? 'sg-word--disabled' : '',
                            ].join(' ')}
                        >
                            {word}
                        </button>
                    ))}
                </div>
            ) : (
                <span className="sg-faint" style={{ fontWeight: 600, fontSize: '0.9rem' }}>No words yet</span>
            )}
        </div>
    );
};

export default PlayerWords;
